import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="w-full py-16 md:py-24 bg-[#F6EBE5]/90" data-id="element-135">
      <motion.div className="max-w-3xl mx-auto px-6" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-136">
        <div className="font-inter text-lg md:text-xl text-charcoal/90 leading-relaxed space-y-6" data-id="element-137">
          <p className="font-semibold text-sage" data-id="element-138">Son las 2:47 de la tarde.</p>

          <p className="font-['Tiro_Gurmukhi',_serif]" data-id="element-139">
            Estás en tu escritorio, o en el coche, o quizás en medio de una fila
            en el supermercado. Y de repente... aparece. Ese "click" en el
            pecho. Esa presión que sube por la garganta. Esa voz que susurra:
            "¿Y si esta vez es diferente? ¿Y si esta vez no puedes parar?"
          </p>

          <p className="font-['Times_New_Roman',_serif]" data-id="element-140">
            No hay razón aparente. No pasó nada "grave". Y aun así, tu corazón
            late como si estuvieras escapando de algo que solo tú puedes ver.
          </p>

          <p className="font-['Times_New_Roman',_serif]" data-id="element-141">
            Lo has intentado todo. Respirar hondo. Contar hasta diez. Poner
            música relajante. Pero cuando la ola viene, se lleva todo. Y lo peor
            no es el episodio en sí. Lo peor es el miedo al próximo episodio. La
            anticipación constante. Esa sensación de caminar sobre hielo fino
            todo el día, esperando el crujido.
          </p>

          <p className="font-semibold text-charcoal font-['Tiro_Gurmukhi',_serif]" data-id="element-142">
            Lo que vas a descubrir en los próximos minutos no es otra "técnica
            de relajación". Es el protocolo que tu sistema nervioso ya sabe
            ejecutar, pero que nadie te enseñó a activar. En menos de 5 minutos,
            puedes tomar el control. No mañana. No después de una semana de
            práctica. Ahora.
          </p>
        </div>
      </motion.div>
    </section>;
}